import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {ACTION_REPRICING} from "../../../@constants";
import {useRepricingFormData} from "../../@hooks";
import {disabledRepricing} from "../../../@signals";


const OPTIONS = [
	{ label: 'Increase', value: ACTION_REPRICING.INCREASE },
	{ label: 'Decrease', value: ACTION_REPRICING.DECREASE },
	{ label: 'Match', value: ACTION_REPRICING.MATCH }
]

export default function RepricingFormActionRepricingSelect() {
	const { actionRepricing, handleChangeValue } = useRepricingFormData()

	if (!!disabledRepricing.value)
		return <></>

	return <SelectSeeker
		options={OPTIONS}
		value={actionRepricing}
		onChange={e => handleChangeValue('action', e.target.value)}
	/>
}